<template>
  <div v-if="balanceInfo" class="tab-wrapper">
    <h3 class="mb16">结算信息</h3>
    <div class="content">
      <div class="item pt16 pb16 mb16">
        <h4 class="mb8">结算明细</h4>
        <table-list :showPage="false" :columns="balanceColums" :data="surrenderBanlances"
                    :loading="balanceLoading"></table-list>
      </div>
      <!--<div class="bold">未核销账单汇总:</div>-->
      <div class="notopcheck mb32"  >
        <h4 class="mb8">未核销账单</h4>
        <!--<Table ref="billTable" :data="dataBill" :columns="columnsBill"></Table>-->
        <div>
          <Row class="row">
            <Col span="5">帐单编号</Col>
            <Col span="5">费用项</Col>
            <Col span="5">账单金额</Col>
            <Col span="5">核销状态</Col>
            <Col span="4"></Col>
          </Row>
          <Row class="row" v-for="item,index in dataBill" :key="'keyTF'+index">
            <Col span="5">{{item.billNumber}}</Col>
            <Col span="5">{{item.finExpenseItemName || '-'}}</Col>
            <Col span="5" style="text-align: right">{{Number(item['feeAmount']/100).toFixed(2)}}</Col>
            <Col span="5">{{item.verificateStatusName}}</Col>
            <Col span="4">
              <Checkbox v-model="item.selected" @on-change="checkNoItem(item)" disabled></Checkbox>
            </Col>
          </Row>
          <div v-if="!dataBill.length"  class="row ivu-row">暂无数据</div>


      </div>
    </div>
      <div class="notopcheck mb32">
        <h4 class="mb8">已核销账单 <a @click = "getCancelBillsInfo" href="javascript:void(0)">{{ isShowCancelDataBill ? '收起 ⮝':'展开 ⮟' }}</a></h4>
        <div v-if = "isShowCancelDataBill">
          <Row class="row">
            <Col span="5">帐单编号</Col>
            <Col span="5">费用项</Col>
            <Col span="5">账单金额</Col>
            <Col span="5">核销状态</Col>
          </Row>
          <Row class="row" v-for="item,index in cancelDataBill" :key="'keyTF'+index">
            <Col span="5">{{item.billNumber}}</Col>
            <Col span="5">{{item.finExpenseItemName || '-'}}</Col>
            <Col span="5" style="text-align: right">{{Number(item['feeAmount']/100).toFixed(2)}}</Col>
            <Col span="5">{{item.verificateStatusName}}</Col>
          </Row>
          <div v-if="!cancelDataBill.length" class="row ivu-row">暂无数据</div>
        </div>
      </div>
      <div class="item pt16 pb16">
        <Row>
          <Col span="8"><span>{{balanceInfo.payerName ==="乙方"?"乙方付款":"乙方收款" || ''}}：{{balanceInfo.costAmount}}</span></Col>
          <!-- <Col span="8">付款金额：<span class="info"></span></Col> -->
        </Row>
      </div>
    </div>
    <div class="item pt16 pb16">
      <div>
        <h4 class="mb8" v-if="balanceInfo.receivingName==='乙方' && balanceInfo.receiptType && balanceInfo.costAmount > 0">乙方储存账户信息</h4>
        <div class="table-wrap" v-if="balanceInfo.receivingName==='乙方' && balanceInfo.receiptType && balanceInfo.costAmount > 0">
          <table class="ivu-table" cellspacing="0" cellpadding="0" border="0">
            <thead>
            <tr>
              <th>开户行名称</th>
              <th>开户人名称</th>
              <th>银行账号</th>
              <th>证件号</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="ivu-table-column-center">{{balanceInfo.bankName}}</td>
              <td class="ivu-table-column-center">{{balanceInfo.accountName}}</td>
              <td class="ivu-table-column-center">{{balanceInfo.bankAcount}}</td>
              <td class="ivu-table-column-center">{{balanceInfo.certificatesCode}}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-if="balanceInfo.payerName==='甲方' && !balanceInfo.receiptType" style="text-align: center;font-weight: bold;">
          <span>本次退款将打入签约主体的自如账户空间内（三天不满意解约将原路退回）。</span>

        </div>

      </div>





    </div>
    <div class="item pt16 pb16">
      <h4 class="mb8">备注：</h4>
      <Input type="textarea" :disabled="true" :autosize="true" :value="balanceInfo.costRemark"></Input>
    </div>



    <div class="item pt16 pb16" v-if="!balanceInfo.receiptType">
      <h4 class="mb8">{{balanceInfo.payerName==='甲方'?'付款信息':'收款信息'}} <span class="text-red" style="float: right">{{infoData.length?infoData[0]['balanceStatusName']:''}}</span></h4>
      <Table :columns="columnCase1" :data="infoData" class="mb8" v-if="balanceInfo.payerName==='甲方'"></Table>
      <Table :columns="columnCase2" :data="infoData" v-if="balanceInfo.payerName==='乙方'"></Table>
    </div>

    <refund-detail :n="ShowDetailKey" :busId="busId"></refund-detail>
    <div class="item pt16 pb16" v-if="balanceInfo.receiptType">
      <h4 class="mb8">结算详情</h4>
      <div v-if="timeLine.length === 0">暂无</div>
      <Timeline v-else>
        <TimelineItem v-for="(item,index) in timeLine" :key="index">
            <p class="time">{{item.handleTime}}</p>
            <p :class="{'content':true,'red':item.paymentStatus === 2 || item.sepStatus === 2}">
              {{item.showText}}
              <span v-if="item.paymentStatus === 2 || item.sepStatus === 2" @click="reTry(item)" class="themeColor">失败重试</span>
            </p>
        </TimelineItem>
    </Timeline>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import defaultImg from '@/assets/filedefault.jpg'
  import TableList from "components/TableList/index";
  import {getSurrenderBalancePaymentsInfo,surrenderBalanceInfoLFT,lftSurrenderBalanceRenewOperate} from "../../../../../api/contractList";
  import {getNoCancelBillsInfo} from "../../../../../api/contractList";
  import {surrenderBalancePayment} from "../../../../../api/contractList";
  import RefundDetail from './RefundDetail'

  export default {
    props: {
      contractCode:{
        type: String,
        default:''
      },
      balanceInfo: {
        type: Object,
        default: null
      },
      surrenderFid: {
        type: String,
        default: ''
      },
    },
    created() {
      this.getSurrenderBalancePaymentsInfo()
      this.getNoCancelBillsInfo()
    },
    components: {
      TableList,
      RefundDetail

    },
    watch: {
      balanceInfo: {
        deep: true,
        handler(val) {
          if (val.totalCostItem !== null) {
            this.surrenderBanlances = val.totalCostItem
          }
          //console.log(this.surrenderBanlances)
        }
      },
      contractCode(val){
        this.surrenderBalanceInfoLFT(val);
      }
    },
    data() {
      return {
        timeLine:[],
        columnsBill: [
          {
            title: "帐单编号",
            key: "billNumber",
            align: "center"
          },
          {
            title: "费用项",
            key: "finExpenseItemName",
            align: "center"
          },
          {
            title: "账单金额",
            key: "feeAmount",
            align: "center",
            render:(h,params)=>{
              return h('span',{
                style:{
                  color:'red'
                }
              },(params.row['feeAmount']/100).toFixed(2))
            }


          },
          {
            title: "核销状态",
            key: "verificateStatusName",
            align: "center"
          },
          // {
          //   type: 'selection',
          //   width: 60,
          //   align: 'center'
          // },

        ],
        dataBill: [],
        cancelDataBill: null,
        isShowCancelDataBill: false,
        infoData: [],
        defaultImg: defaultImg,
        balanceLoading: false,
        columnCase1: [
          {
            title: "付款单号",
            key: "billNum",
            align: "center"
          },
          {
            title: "提交时间",
            key: "submitTime",
            align: "center"
          },
          {
            title: "打款时间",
            key: "paymentTime",
            align: "center"
          },
          {
            title: "付款状态",
            key: "paymentStatusName",
            align: "center",
            render:(h,params)=>{
              return h('span',{
                style:{
                  color:'red'
                }
              },params.row['paymentStatusName'])
            }
          },
          {
            title: "操作",
            key: "",
            align: "center",
            render: (h, params) => {
              if (params.row['operateState'] === 1) {
                return h('a', {
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '付款异常处理',
                        content: '<p>继续操作将重新生成付款单并执行打款流程，请问是否继续？</p>',
                        onOk: () => {
                          surrenderBalancePayment({busId:  params.row['busId']}).then(res => {
                            this.$Message.success('操作成功')

                          }).catch(error => {

                          }).finally(() => {
                            this.getSurrenderBalancePaymentsInfo()
                          })
                        }
                      })
                    }
                  }
                }, '重新付款')

              }else if(params.row['sceneType']===1) {
                return h('a', {
                  on: {
                    click: () => {
                      this.busId= params.row['busId'];
                      this.ShowDetailKey++
                    }
                  }
                }, '付款明细')
              }else {
                return h('span', {}, '')
              }

            }
          }


        ],
        columnCase2: [
          {
            title: "账单号",
            key: "billNum",
            align: "center"
          },
          {
            title: "提交时间",
            key: "submitTime",
            align: "center"
          },
          {
            title: "核销时间",
            key: "paymentTime",
            align: "center"
          },
          {
            title: "收款状态",
            key: "paymentStatusName",
            align: "center",
            render:(h,params)=>{
              return h('span',{
                style:{
                  color:'red'
                }
              },params.row['paymentStatusName'])
            }
          },
          {
            title: "操作",
            key: "",
            align: "center",
          }
        ],


        balanceColums: [
          {
            title: "费用项",
            key: "expenseItemName",
            align: "center"

          },
          {
            title: "应缴费用",
            key: "receivableAmount",
            align: "center",
            render:(h,params)=>{
              return h('div',{
                style:{
                  // width:'100px',
                  textAlign:'right'
                }

              },params.row['receivableAmount'])
            },
          },
          {
            title: "已缴费用",
            key: "receivedAmount",
            align: "center",
            render:(h,params)=>{
              return h('div',{
                style:{
                  // width:'100px',
                  textAlign:'right'
                }

              },params.row['receivedAmount'])
            },
          },
          {
            title: "应退费用",
            key: "refundAmount",
            align: "center",
            render:(h,params)=>{
              return h('div',{
                style:{
                  // width:'100px',
                  textAlign:'right'
                }

              },params.row['refundAmount'])
            },
          },
          {
            title: "实退费用",
            key: "actRefundAmount",
            align: "center",
            render:(h,params)=>{
              return h('div',{
                style:{
                  // width:'100px',
                  textAlign:'right'
                }

              },params.row['actRefundAmount'])
            },
          }
        ],
        surrenderBanlances: [],
        ShowDetailKey:0,
        busId:''
      };
    },
    methods: {
      reTry(item){
        lftSurrenderBalanceRenewOperate(item)
        .then(res=>{
          this.$Message.success('操作成功')
          this.surrenderBalanceInfoLFT(this.contractCode);
        })
        .catch(err=>{
          console.log(err,'err')
        })
      },
      surrenderBalanceInfoLFT(val){
        surrenderBalanceInfoLFT({
          contractCode: val
        })
        .then(res=>{
          this.timeLine = res.data;
        })
      },
      getSurrenderBalancePaymentsInfo() {
        const params = {
          surrenderFid: this.surrenderFid
        }
        getSurrenderBalancePaymentsInfo(params).then(res => {
          if(!res.data){
            return
          }
          this.infoData=res.data
        }).catch(error => {

        })

      },
      getNoCancelBillsInfo() {
        const params = {
          surrenderFid: this.surrenderFid
        }
        getNoCancelBillsInfo(params).then(res => {
          if(!res.data){
            return

          }
          this.dataBill=res.data

        }).catch(error => {
          const res = [{
            "billNumber": "string",
            "cancelBillFid": "string",
            "feeAmount": 0,
            "finExpenseItemName": "水费",
            "verificateStatus": 0,
            "verificateStatusName": "string"
          }]

          this.dataBill = res

        })

      },
      getCancelBillsInfo() {
        this.isShowCancelDataBill = ! this.isShowCancelDataBill;
        if(this.cancelDataBill != null) return;
        const params = {
          surrenderFid: this.surrenderFid,
          noCancel: 0
        }
        getNoCancelBillsInfo(params).then(res => {
          if (!res.data) {
            return

          }
          this.cancelDataBill = res.data
        }).catch(error => {
          this.cancelDataBill = []
        })
      },
    }
  }
</script>

<style scoped>
  .time{
        font-size: 14px;
        font-weight: bold;
    }
    .content{
        padding-left: 5px;
    }
  .row {
    text-align: center;
    /*margin-bottom: 10px;*/
    line-height: 32px;
    border-left: 1px solid rgb(222, 222, 222);
    border-right: 1px solid rgb(222, 222, 222);
    border-bottom: 1px solid rgb(222, 222, 222);
    padding: 7px;
    font-weight: bold;
  }

  .row:first-child {
    border-top: 1px solid rgb(222, 222, 222);
    background-color: rgb(248, 248, 248);
    padding: 5px;
  }
  .info {
    padding-left: 8px;
    font-weight: 600;
  }

  .table-wrap {
    position: relative;
    border: 1px solid #dddee1;
    border-bottom: 0;
    border-right: 0;
  }

  table {
    width: 100%;
  }

  th, td {
    text-align: center;
  }
  .red{
    color: red;
  }
  .themeColor{
    cursor: pointer;
    color: #CFA868;
  }

</style>



